export const globalConfig = {
    auth0: {
        clientId: "",
        domain: "",
        redirectUri: "",
        audience: "",
    },
    // newartist: false,
    // country: "",
    google: {
        apiKey: "",
        analyticsId: "",
    },
    // appInsights: {
    //     key: "",
    // }
}